/**
 * Service Provider Configuration - Clean Version
 * 
 * This file determines which service implementation to use based on the deployment environment:
 * - For Electron: Local API with IPC
 * - For Browser/Web: Local API with HTTP or Cloudflare-based services
 */

import { isBrowserMode } from './browserMode';
import CloudflareServices from '../../core/services/cloudflareAdapter';
import LocalApiServices from '../../core/services/localApiAdapter';
import { API_BASE } from './apiConfig';
import { isCloudDemoRuntime } from './publicDemoRuntime';

// Determine if we're running in a web browser or Electron
const isElectron = (typeof window !== 'undefined' && window.electronAPI !== undefined) || false;
const isWebBrowser = isBrowserMode();
const isLocalApi = API_BASE && API_BASE.includes('localhost');
const isWorkersFunctionsApi = API_BASE && API_BASE.includes('/functions');
const IS_CLOUD_DEMO = isCloudDemoRuntime();

console.log('🔌 ServiceProvider Detection:', { 
  isElectron, 
  isWebBrowser, 
  isLocalApi,
  isCloudDemo: IS_CLOUD_DEMO,
  hasElectronAPI: typeof window !== 'undefined' && window.electronAPI !== undefined 
});

// Choose the appropriate service implementation
let ServiceProvider;

if (!isWebBrowser || isElectron) {
  // Electron mode - use LocalApiServices (has built-in Electron detection)
  console.log('🔌 Using LocalApiServices for Electron mode');
  ServiceProvider = LocalApiServices;
} else if (IS_CLOUD_DEMO) {
  // Browser cloud demo: localApiAdapter uses in-browser demo store (no Workers /functions)
  console.log('🧪 Using LocalApiServices for cloud demo (in-browser demo DB + localStorage)');
  ServiceProvider = LocalApiServices;
} else if (isWorkersFunctionsApi) {
  // Legacy Cloudflare Workers /functions API
  console.log('☁️ Using CloudflareServices for Workers /functions API');
  ServiceProvider = CloudflareServices;
} else {
  // Railway, localhost, or any Express /api host
  console.log('🌐 Using LocalApiServices for Express API backend');
  ServiceProvider = LocalApiServices;
}

export default ServiceProvider;

// Export individual services for convenience
export const clientService = ServiceProvider.clients;
export const invoiceService = ServiceProvider.invoices || ServiceProvider.documents;
export const productService = ServiceProvider.products;
export const settingsService = ServiceProvider.settings;
export const dashboardService = ServiceProvider.dashboard;
export const employeeService = ServiceProvider.employees;
export const categoryService = ServiceProvider.categories;
export const supplierService = ServiceProvider.suppliers;
export const partnerService = ServiceProvider.partners;
export const documentService = ServiceProvider.documents;
export const paymentService = ServiceProvider.payments;
export const financeService = ServiceProvider.finances;
export const analyticsService = ServiceProvider.analytics;
export const departmentService = ServiceProvider.departments;
export const timetrackingService = ServiceProvider.timetracking;

console.log('✅ ServiceProvider configured successfully:', {
  provider: isElectron ? 'Electron IPC' : IS_CLOUD_DEMO ? 'Demo local DB' : isWorkersFunctionsApi ? 'Cloudflare Workers' : 'Express API',
  services: Object.keys(ServiceProvider)
});


